import { Toaster as Sonner, type ToasterProps } from 'sonner'

/**
 * The sonner <Toaster> host, themed to the design's toast: a dark (#1C1A22)
 * bottom-center pill with white 13.5px text, an 11px radius, a deep soft
 * shadow, and a teal check icon (the icon tint lives in globals.css —
 * `[data-sonner-toast] [data-icon]`). The shell mounts it once with
 * `position="bottom-center"`; light-only surface, so the theme is pinned.
 */
const Toaster = ({ ...props }: ToasterProps) => {
  return (
    <Sonner
      theme="light"
      className="toaster group"
      position="bottom-center"
      toastOptions={{
        style: {
          background: '#1C1A22',
          color: '#ffffff',
          border: 'none',
          borderRadius: '11px',
          padding: '13px 22px',
          fontSize: '13.5px',
          fontWeight: 500,
          boxShadow: '0 12px 34px rgba(0,0,0,.22)',
        },
      }}
      style={
        {
          '--normal-bg': '#1C1A22',
          '--normal-text': '#ffffff',
          '--normal-border': 'transparent',
          '--toast-close-button-start': 'unset',
          '--toast-close-button-end': '0',
          '--toast-close-button-transform': 'translate(35%, -35%)',
        } as React.CSSProperties
      }
      {...props}
    />
  )
}

export { Toaster }
